import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Boundary caught error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          padding: '2rem',
          textAlign: 'center',
          background: '#0f172a',
          color: 'white',
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <h1 style={{ color: '#ef4444' }}>Something went wrong</h1>
          <p style={{ color: '#94a3b8', maxWidth: '500px' }}>
            A technical error occurred. Please try refreshing the page or contact support if the problem persists.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              marginTop: '1.5rem',
              padding: '0.75rem 1.5rem',
              background: '#6366f1',
              border: 'none',
              borderRadius: '0.5rem',
              color: 'white',
              cursor: 'pointer',
              fontWeight: 600
            }}
          >
            Refresh Page
          </button>

          {process.env.NODE_ENV === 'development' && (
            <div style={{
              marginTop: '2rem',
              textAlign: 'left',
              background: '#1e293b',
              padding: '1rem',
              borderRadius: '0.5rem',
              maxWidth: '90%',
              overflow: 'auto'
            }}>
              <p style={{ color: '#ef4444', margin: '0 0 0.5rem 0' }}>Error Details:</p>
              <pre style={{ margin: 0, fontSize: '0.8rem', color: '#cbd5e1' }}>
                {this.state.error?.toString()}
              </pre>
            </div>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;